import { cn } from '@/lib/utils'
import { PosCartContent, type PosCartLine } from './PosCartContent'
import type { PosPaymentMethod } from './posApi'

type Props = {
  saleStep: 'edit' | 'review'
  cartLines: PosCartLine[]
  currency: string
  storeName?: string | null
  subtotal: number
  taxTotal: number
  grandTotal: number
  paymentMethod: PosPaymentMethod
  submitting: boolean
  storeId: number | null
  onPaymentMethodChange: (method: PosPaymentMethod) => void
  onAdjustQty: (productId: number, delta: number) => void
  onClearCart: () => void
  onCheckout: () => void
  onBackToEdit: () => void
  onFinalize: () => void
  className?: string
}

/** Always-visible cart column for desktop / tablet (lg+). */
export function PosCartPanel({ className, saleStep, ...contentProps }: Props) {
  return (
    <aside
      className={cn(
        'border-border bg-card hidden min-h-0 w-full max-w-md shrink-0 flex-col rounded-2xl border p-4 shadow-sm lg:flex',
        className,
      )}
      aria-label={saleStep === 'review' ? 'Confirm this sale' : 'Current sale cart'}
    >
      <PosCartContent saleStep={saleStep} {...contentProps} />
    </aside>
  )
}
